var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserControlerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_394_400)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 22,
    height: 22,
    rx: 2,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.90597 17.5135C7.87474 17.5135 7.84269 17.5108 7.81065 17.5049C7.51769 17.4526 7.32274 17.1729 7.37524 16.8799C7.66955 15.2344 8.64404 13.9279 10.0491 13.2951C10.9775 12.8772 12.106 12.6831 13.3053 12.7337C14.6816 12.7916 15.7729 13.1013 16.6416 13.6799C17.7154 14.4401 18.4338 15.609 18.625 16.8955C18.6686 17.1896 18.4656 17.4634 18.1713 17.5073C17.8781 17.5512 17.6034 17.3479 17.5595 17.0536C17.4114 16.0562 16.8546 15.1501 16.0317 14.5677C15.3443 14.1099 14.4336 13.8592 13.2601 13.8097C12.2224 13.7658 11.2675 13.9279 10.4915 14.2774C9.41576 14.7618 8.66639 15.7794 8.43562 17.0695C8.38904 17.3304 8.16205 17.5135 7.90597 17.5135Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9824 13.8033C12.7169 13.8033 12.4527 13.7672 12.1977 13.6956C10.7375 13.286 9.81039 11.7951 10.0864 10.3017C10.3573 8.83579 11.7596 7.75441 13.2727 7.89389C14.7803 8.03256 15.9608 9.32801 15.9608 10.8435C15.9608 11.2051 15.8961 11.5589 15.7685 11.895C15.335 13.0364 14.2151 13.8033 12.9824 13.8033ZM13.0069 8.95885C12.1078 8.95885 11.3075 9.62044 11.1454 10.4977C10.9696 11.4488 11.5593 12.3979 12.4883 12.6586C12.6488 12.7036 12.8149 12.7262 12.9821 12.7262C13.7708 12.7262 14.4857 12.2385 14.7612 11.5126C14.8425 11.2991 14.8834 11.074 14.8834 10.8435C14.8834 9.87894 14.1324 9.05471 13.1738 8.96665C13.1181 8.96127 13.0624 8.95885 13.0069 8.95885Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.981 19.9956C12.9807 19.9956 12.9807 19.9956 12.9804 19.9956C12.3684 19.9956 11.7612 19.9159 11.1761 19.7584C8.65463 19.0804 6.68008 16.9914 6.14585 14.4368C5.60193 11.8343 6.60657 9.09856 8.70525 7.46706C9.91884 6.52381 11.4491 6.00439 13.0146 6.00439C14.0984 6.00439 15.1747 6.25643 16.1274 6.73277C18.4797 7.90974 20 10.3687 20 12.9976C20 15.1426 18.9878 17.21 17.2925 18.5278C16.0746 19.4743 14.543 19.9956 12.981 19.9956ZM13.0146 7.08147C11.6874 7.08147 10.3917 7.52038 9.3663 8.31768C7.58994 9.69822 6.73986 12.0139 7.20031 14.2166C7.65214 16.3774 9.32268 18.1446 11.4558 18.7185C11.9497 18.8512 12.4626 18.9188 12.9807 18.9188H12.981C14.3052 18.9188 15.6015 18.478 16.6314 17.6775C18.0661 16.5622 18.9229 14.8124 18.9229 12.9976C18.9229 10.7731 17.6366 8.69224 15.6457 7.69621C14.8419 7.29392 13.932 7.08147 13.0146 7.08147Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_394_400",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_394_400"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_394_400",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserControlerIcon);
export default __webpack_public_path__ + "static/media/userControlerIcon.15eb24af1ba46666605b5bb5cedeb94d.svg";
export { ForwardRef as ReactComponent };